import { makeStyles } from "@fluentui/react-components";
import SEO from "../../../app/SEO";
import Hero from "../../../components/hero/Hero";
import { useTranslation } from "react-i18next";
import Vacancies from "./Vacancies";
import ApplicationForm from "./ApplicationForm";
import { useHeroMainSnap } from "../../../hooks/useHeroMainSnap";

const useStyles = makeStyles({
    root: {
        padding: 0,
        backgroundColor: '#f5f5f5',
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "40px",
        maxWidth: "1500px",
        margin: "0 auto"
    },
});

export default function JobListing() {
    const { t } = useTranslation("recruitment");
    const styles = useStyles();

    // Snap scrolling behaviour for this page
    useHeroMainSnap("recruitment-hero", "recruitment-main", {
        duration: 900,
        easing: "quart",
        heroCapturePx: 80,
        upCapturePx: 300,
        headerOffset: 0
    });

    const metaDescription = t("metaDescription");
    const bannerImageUrl = "/img/banners/recruitment.webp";

    return (
        <div className={styles.root}>
            
            <SEO
                title={{ pageTitle: t("hero.title"), title: t("hero.title") }}
                metaDescription={metaDescription}
                canonicalPath={`/jobs`}
                openGraph={{
                    title: t("hero.title"),
                    description: metaDescription,
                    image: bannerImageUrl,
                    url: "/jobs"
                }}
                />

            <div id="recruitment-hero">
                <Hero
                    title={t("hero.title")}
                    subtitle={t("hero.description")}
                    imageUri={bannerImageUrl}
                    />
            </div>

            <div id="recruitment-main" className={styles.container}>
                <Vacancies />
                <ApplicationForm />
            </div>
        </div>
    );
}